import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {HTTP_STATUS_OK} from '../../../Constants'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {QueryKeyManager} from '../../../query-manager/QueryKeysManager'
import {createOrUpdateProfile} from '../../information/ProfileEndPoint'
import {severityNotification} from '../../notification/NotificationConstant'
import {showNotification} from '../../notification/NotificationService'
import {getUserAuthData} from '../AuthEndPoints'

export function setStorageUserTokenInfo(data) {
    localStorage.setItem('userTokenInfo', JSON.stringify(data))
}

export function getStorageUserTokenInfo() {
    const storageUserTokenInfo = localStorage.getItem('userTokenInfo')

    if (!storageUserTokenInfo || storageUserTokenInfo === 'undefined') {
        return {}
    }

    try {
        return JSON.parse(storageUserTokenInfo)
    } catch {
        return {}
    }
}

export const useAuthTokenInfo = requestorId => {
    const {authKeys} = QueryKeyManager(
        QueryKeyTypes.authentication,
        requestorId,
    )
    return useQuery({
        queryKey: authKeys.detail({id: requestorId}),
        queryFn: () => getUserAuthData(requestorId),
        enabled: !!requestorId,
        placeholderData: getStorageUserTokenInfo() || {},
    })
}

export const useAuthTokenInfoCRUD = requestorId => {
    const {authKeys} = QueryKeyManager(
        QueryKeyTypes.authentication,
        requestorId,
    )

    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: data => createOrUpdateProfile(requestorId, data),
        onSuccess: data => {
            if (data && (data === HTTP_STATUS_OK || data?.id)) {
                queryClient.invalidateQueries({
                    queryKey: authKeys.pattern(),
                })
                showNotification(
                    severityNotification.success,
                    'Update profile success!!',
                )
            }
        },
    })
}
